<ol  class="d-flex align-items-center p-0 m-0" style="gap:5px;">
    <li class="breadcrumb-item" *ngFor="let breadcrumb of this.customBreadcrumb" style="list-style-type: none;">
        <a class="field-link-breadcrumb" href="{{breadcrumb['url']}}" *ngIf="breadcrumb['isActive'] == true">{{breadcrumb['label']}}</a>
        <span *ngIf="breadcrumb['isActive'] == false">{{breadcrumb['label']}}</span>
    </li>
</ol>
